import Link from 'next/link';
import { env } from '@zopauk/nextjs-env';
import { B2BNavLink } from './B2BNavLink';
import { CustomNavLink } from './CustomNavLink';
import { logB2BEvent } from '@/utils/analytics';
import Events from '@/utils/amplitudeEvents.json';
import { Navigation, Button } from '@zopauk/web-ui';
import { getNavItems } from '@/components/Navigation/constants';

type NavbarProps = {
  isBusiness?: boolean;
};

export const Navbar = ({ isBusiness }: NavbarProps) => {
  const signInHref = isBusiness ? 'https://dash.zopa.com' : env('NEXT_PUBLIC_WEB_HUB_URL') || '';

  const businessCTA = (
    <div className="flex items-center gap-3">
      <Button
        onClick={() => {
          logB2BEvent(Events.B2B_NAV_CLICK, { nav_item: 'Talk to the Team' });
          logB2BEvent(Events.B2B_CONVERSION_CLICK, { conversion_type: 'book_a_demo' });
        }}
        href="mailto:partnerships@zopa.com?subject=Talk%20to%20the%20Team"
        data-automation="Business_SpeakToTheTeam.topBar.Button"
        variant="secondary"
        as="a"
      >
        Speak to the team
      </Button>
      <Button href={signInHref} variant="primary" className="ml-3" as={Link}>
        Sign in
      </Button>
    </div>
  );

  return (
    <div data-automation="ZA.navbar-desktop">
      <Navigation
        profileProps={{
          className: isBusiness ? '[&_.material-symbols-outlined]:text-background' : undefined,
          href: signInHref,
        }}
        logoProps={{
          href: isBusiness ? '/business' : '/',
        }}
        ctaProps={isBusiness ? undefined : { href: signInHref, as: Link }}
        renderLinkAs={isBusiness ? B2BNavLink : CustomNavLink}
        customCTA={isBusiness ? businessCTA : undefined}
        navigationList={getNavItems(isBusiness)}
      />
    </div>
  );
};
